var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex purchase justify-content-center general"},[_c('Purchase',{staticClass:"isDesktop"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }